export const CRM_INTEGRATION_TYPES = ['caspio', 'platform'] as const;

export type CrmIntegrationType = (typeof CRM_INTEGRATION_TYPES)[number];

export const PLATFORM_CRM_TABLE = 'staging.stg_waiver_raw';

export const CRM_COLUMN_PATTERN = '^[A-Za-z_][A-Za-z0-9_]*$';

export const PLATFORM_TABLE_PATTERN = '^[a-z_][a-z0-9_]*\\.[a-z_][a-z0-9_]*$';

export function isCrmIntegrationType(value: unknown): value is CrmIntegrationType {
  return CRM_INTEGRATION_TYPES.some((x) => x === value);
}
